import React, { useState } from "react";
import { Menu, MenuItem, Icon, Modal, Segment, Label } from "semantic-ui-react";
import moment from "moment";

const LastFoldersSupportedModal = ({ getLastFoldersSupported, countMyFolders }) => {
	const [lastFolderHelps, setLastFolderHelps] = useState([]);
	return (
		<Modal
			trigger={
				<Menu compact>
					<Menu.Item
						as="a"
						onClick={() =>
							getLastFoldersSupported().then((res) => {
								if (res && res.payload && res.payload.data) setLastFolderHelps(res.payload.data);
							})
						}
					>
						<Icon name="calendar check outline" />
						Mes dossiers
						{countMyFolders >= 0 && (
							<Label color="teal" floating>
								{countMyFolders}
							</Label>
						)}
					</Menu.Item>
				</Menu>
			}
			header="Mes derniers dossiers pris en charge (< 30 min)"
			content={
				<Segment>
					{lastFolderHelps
						.slice()
						.sort((a, b) => moment(a.created_at) - moment(b.created_at))
						.map((h) => (
							<p>
								{moment(h.created_at).format("HH:mm:ss")} - {h.folderHelp?.folder?.patient?.birth_name}{" "}
								{h.folderHelp?.folder?.patient?.married_name ? `${h.folderHelp?.folder?.patient?.married_name} ` : ""}
								{h.folderHelp?.folder?.patient?.first_name} - Dossier {h.folderHelp?.folder?.code} -{" "}
								{h.folderHelp?.folder?.labAppointment?.center?.name}
							</p>
						))}
				</Segment>
			}
			actions={[{ key: "done", content: "OK", positive: true }]}
		/>
	);
};
export default LastFoldersSupportedModal;
